import {common} from "../global/common.js"
import {api} from "../global/framework/api.js";

const SESSION_KEY = "acressaImpersonationSession";

let memberAccessAcknowledgementPrompt = null;

function decodeJwtPayload(token) {
    if (!token) return null;
    const raw = String(token).replace(/^Bearer\s+/i, "");
    const parts = raw.split(".");
    if (parts.length < 2) return null;
    try {
        const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
        return JSON.parse(window.atob(padded));
    } catch (e) {
        return null;
    }
}

function parseImposter(payload) {
    if (!payload || !payload.imposter) return null;
    try {
        return typeof payload.imposter === "string" ? JSON.parse(payload.imposter) : payload.imposter;
    } catch (e) {
        return null;
    }
}

function isConsumerImpersonation(entityTypeId, dashboard) {
    const dash = dashboard ? String(dashboard).toLowerCase() : "";
    return entityTypeId === common.ENTITY_TYPE.CONSUMER || dash === "consumer" || dash === "member";
}

export const impersonationHelper = {
    async impersonate({entityId, entityTypeId}, userId = null, redirectUrl = null, tokenInfo = null, returnLabel = null) {
        if (!tokenInfo) tokenInfo = await api.getDataWithTwoIds('Admin', entityId, 'GetImpersonationToken', entityTypeId);

        const session = {
            token: localStorage.acressaToken || null,
            returnUrl: window.location.href,
            returnLabel: returnLabel || "Return to Dashboard"
        };
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));

        $.ajax({
            type: "POST",
            disablePrefilter: true,
            disableBeforeSendHandler: true,
            url: common.APP_CONFIG.ROOT_URL + "AcressaOAuth/token",
            data: {
                associatedUserId: tokenInfo.userId,
                tempAuthToken: tokenInfo.tempToken,
                userToImpersonate: userId || tokenInfo.userToImpersonate,
                grant_type: "password",
                client_id: "AcressaJsApp"
            },
            success: function (tokenResponse) {
                localStorage.acressaToken = 'Bearer ' + tokenResponse.access_token;
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                    return;
                }
                const memberId = tokenInfo.primaryConsumerId || entityId;
                if (isConsumerImpersonation(entityTypeId, tokenInfo.dashboard)) {
                    window.location.href = `/member/#/${memberId}/dashboard`;
                    return;
                }
                window.location.href = `/${tokenInfo.dashboard.toLowerCase()}/#/${entityId}/dashboard`;
            }
        });
    },

    setMemberAccessAcknowledgementPrompt(prompt) {
        memberAccessAcknowledgementPrompt = prompt;
    },

    async impersonateAsMember(mediatorId, consumerId, redirectUrl = null) {
        const accepted = await this.confirmMemberAccessAcknowledgement();
        if (!accepted) {
            return;
        }
        const tokenInfo = await api.getDataWithTwoIds('Psr', mediatorId, 'GetImpersonationToken', consumerId);
        if (!tokenInfo) {
            return;
        }
        const primaryId = tokenInfo.primaryConsumerId || consumerId;
        await this.impersonate(
            { entityId: primaryId, entityTypeId: common.ENTITY_TYPE.CONSUMER },
            tokenInfo.userToImpersonate,
            redirectUrl,
            tokenInfo,
            "Return to MSR Dashboard"
        );
    },

    async confirmMemberAccessAcknowledgement() {
        if (!memberAccessAcknowledgementPrompt) {
            return false;
        }
        return Boolean(await memberAccessAcknowledgementPrompt());
    },

    getImposter() {
        const payload = decodeJwtPayload(localStorage.acressaToken);
        return parseImposter(payload);
    },

    isImpersonating() {
        return Boolean(this.getImposter());
    },

    getReturnLabel() {
        const session = this.getReturnSession();
        return (session && session.returnLabel) || "Return to Dashboard";
    },

    getImpersonatedMemberName() {
        const payload = decodeJwtPayload(localStorage.acressaToken);
        if (!payload) return "member";
        return payload.fullName || payload.firstName || "member";
    },

    getReturnSession() {
        try {
            const raw = sessionStorage.getItem(SESSION_KEY);
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            return null;
        }
    },

    stopImpersonating() {
        const session = this.getReturnSession();
        sessionStorage.removeItem(SESSION_KEY);
        if (!session || !session.token || !session.returnUrl) {
            common.logOut();
            return;
        }
        localStorage.acressaToken = session.token;
        window.location.href = session.returnUrl;
    }
};
